import type {TeamInvitationRole} from '@mattermost/types/teams';
import type {Channel} from '@mattermost/types/channels';

export const ROLES_MAP: Record<TeamInvitationRole, {name: string; displayName: string}> = {
    team_user: {name: 'User', displayName: 'invite.members.roles.team_user.name'},
    team_guest: {name: 'Guest +', displayName: 'invite.members.roles.team_guest.name'},
    team_restricted_guest: {name: 'Guest', displayName: 'invite.members.roles.team_restricted_guest.name'},
};

export const EMAILS_LIMIT_DEFAULT = 50;
export const CHANNELS_LIMIT_DEFAULT = 10;
export const EMAIL_MAX_LENGTH = 128;
export const AUTOCOMPLETE_CHANNELS_DEFAULT: Channel[] = [];
export const INITIAL_CHANNELS: Channel[] = [];

export const DELAY_MS = 60_000;
